import forEach from 'lodash/forEach';
import { Printd } from 'printd';
import { useCallback } from 'react';

export default function usePrint() {
  const printElement = useCallback((elementOrSelector, iframeId) => {
    const iframe = document.getElementById(iframeId);
    const iframeDocument = iframe ? iframe.contentWindow.document : null;
    const currentDocument = iframe ? iframeDocument : document;

    let element = null;

    if (typeof elementOrSelector === 'string') {
      element = currentDocument.querySelector(elementOrSelector);
    } else {
      element = elementOrSelector;
    }

    if (!element) {
      console.warn(elementOrSelector, 'not found');
      return;
    }

    const headEls = currentDocument.querySelectorAll("style, link[rel='stylesheet']");
    let newStyles = '';

    const startPrint = () => {
      const d = new Printd();
      d.print(element, [newStyles]);
    };

    forEach(headEls, (style, index, array) => {
      newStyles += style.innerHTML;
      if (index === array.length - 1) {
        setTimeout(() => {
          startPrint();
        }, 50);
      }
      return newStyles;
    });
  }, []);

  return { printElement };
}
